import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../../_metronic/layout/core'
import ProfitAndLossListWrapper from '../components/profit-and-loss-list.component'

const profitAndLosssBreadcrumbs: Array<PageLink> = [
  {
    title: 'Activity Report',
    path: '/apps/report/profit-and-loss-management/profit-and-loss',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProfitandLossPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='profit-and-loss'
          element={
            <>
              <PageTitle breadcrumbs={profitAndLosssBreadcrumbs}>Activity Report</PageTitle>
              <ProfitAndLossListWrapper />
            </>
          }
        />
      </Route>
      <Route
        index
        element={<Navigate to='/apps/report/profit-and-loss-management/profit-and-loss' />}
      />
    </Routes>
  )
}

export default ProfitandLossPage
